import { Search, History } from "history";

export interface PresettlementReportQueryProps {
  page: number;
  searchTerm?: string;
  payDate?: string;
}

export function queryParamsToProps(search: Search) {
  const searchParams = new URLSearchParams(search);
  const pageParam = searchParams.get("page");
  const page =  pageParam ? +pageParam : 1;
  const searchTerm = searchParams.get("search") || "";
  const payDate = searchParams.get("payDate") || "";

  return {
    page,
    searchTerm,
    payDate,
  };
}

export function propsToQueryParams(props: PresettlementReportQueryProps) {
  let queryString = `?page=${props.page}`;
  if(props.searchTerm) {
    queryString += `&search=${props.searchTerm}`;
  }
  if(props.payDate) {
    queryString += `&payDate=${props.payDate}`;
  }

  return queryString;
}

export const goToReportPage = (history: History, queryProps: PresettlementReportQueryProps) => {
  history.push(`${propsToQueryParams(queryProps)}`);
};
